
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateChangelogStatusDtoFormGroup() {
return new FormGroup({
    status: new FormControl<string | undefined>('', [Validators.required]),
    resolvedBy: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      